export enum StatusColor {
  New = 'transparent',
  InProgress = '#2196f3',
  Paused = '#ff9800',
  ReadyToCheck = '#9c27b0',
  Checking = '#00bcd4',
  Completed = '#4caf50',
  CheckFailed = '#f44336',
  HasProblem = '#b71c1c',
}
